// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymodesFooter_keto_container__3OtQJ","title":"PaymodesFooter_keto_title__2Jmhu"};